module.exports = __webpack_public_path__ + "static/img/body_bg.9416784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/body_bg.jpg
// module id = Xzbe
// module chunks = 19